import { fetchApi } from '@/config/axiosSetting';
import { PatchSubstitutionPartParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchSubstitutionPart/patchSubstitutionPartQuery.type';

export const PatchSubstitutionPartQueryFunction = (
  params: PatchSubstitutionPartParams,
) => {
  return fetchApi.patch(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/substitution_parts/`,
    params?.data,
    {
      params: {
        damaged_id: params?.damaged_id,
        source: params?.source,
        part_id: params?.partId,
      },
    },
  );
};
